import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import { getToken, clearAuthInfo } from '@/utils/auth'

Vue.use(ElementUI)

// 配置axios请求拦截器，自动添加token
axios.interceptors.request.use(
  config => {
    const url = config.url || ''
    // 确保 headers 存在
    config.headers = config.headers || {}

    const currentPath = router.currentRoute.path
    
    // 大屏页面（/ 和 /store/:storeId）不需要 token
    const isScreenPage = currentPath === '/' || currentPath.startsWith('/store/')

    // 1. 视频相关接口：按页面区分是否携带 token
    // - 大屏页：不携带 token（避免播放依赖登录态）
    // - 管理页：必须携带 token（上传/删除/启用开关等接口需要鉴权）
    //
    // 说明：之前“一刀切不带 Authorization”会导致管理端请求被后端判定未登录（401），
    // 从而触发响应拦截器清除登录信息并跳转登录页，表现为“点启用就退出登录”。
    if (url.startsWith('/api/store-welcome-video/') || url.includes('/api/store-welcome-video/')) {
      if (isScreenPage) {
        if (config.headers.Authorization) {
          delete config.headers.Authorization
        }
      } else {
        const token = getToken()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
      return config
    }

    // 2. 其他接口保持原有逻辑：大屏不带 token，管理端等页面才带 token
    
    // 只有非大屏页面才添加 token
    if (!isScreenPage) {
      const token = getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } else {
      // 大屏页面：明确删除 Authorization header，确保不携带 token
      delete config.headers.Authorization
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 配置axios响应拦截器，处理401未授权错误
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      // 检查是否是登录接口的请求，如果是则不处理，让登录组件自己处理错误
      const requestUrl = error.config?.url || ''
      // 更新登录接口路径检查：从 /api/auth/login 改为 /login
      const isLoginRequest = requestUrl.includes('/login') && requestUrl.endsWith('/login')
      const currentPath = router.currentRoute.path
      
      console.log('[Axios拦截器] 401错误', {
        url: requestUrl,
        isLoginRequest,
        currentPath
      });
      
      // 如果不是登录接口，才执行自动跳转逻辑
      if (!isLoginRequest) {
        // 只在大屏页面以外的页面才自动跳转
        // 大屏页面（/ 和 /store/:storeId）的API调用返回401时不应该跳转
        const isScreenPage = currentPath === '/' || currentPath.startsWith('/store/')
        
        if (!isScreenPage) {
          console.log('[Axios拦截器] 非大屏页面401错误，清除登录信息并跳转');
          // token过期或无效，清除登录信息并跳转到登录页
          clearAuthInfo()
          if (currentPath !== '/login') {
            router.push({
              path: '/login',
              query: { redirect: router.currentRoute.fullPath }
            })
          }
        } else {
          console.log('[Axios拦截器] 大屏页面401错误，不跳转');
        }
      } else {
        console.log('[Axios拦截器] 登录接口401错误，不处理');
      }
    }
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

function updateDisplayMode(path) {
  var wrapper = document.querySelector('.scale-wrapper')
  var html = document.documentElement
  var isAdmin = path && path.indexOf('/admin') === 0
  var isLogin = path && path.indexOf('/login') === 0
  // 登录页面和管理页面都不需要缩放
  if (isAdmin || isLogin) {
    if (html) html.classList.add('admin-mode')
    if (wrapper) wrapper.classList.add('no-scale')
  } else {
    if (html) html.classList.remove('admin-mode')
    if (wrapper) wrapper.classList.remove('no-scale')
  }
}

router.afterEach(function (to) {
  updateDisplayMode(to.path)
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app-original')
